import { capabilitiesForRouteAccess } from '@ingenico/react-section-utils';
import type { Observable } from 'rxjs';
import { filter, firstValueFrom } from 'rxjs';

import { deviceManagementContainer } from '../../container.const';
import { DeviceManagementService } from '../../domain/business/services/deviceManagement.service';
import type { DeviceManagementSpiPort } from '../../domain/hexa/ports/spi.model';

type InnerType<T> = T extends Observable<infer U> ? U : never;

export function applicationVersionPageLoader(spi: DeviceManagementSpiPort) {
  return async ({ params }: { readonly params: Partial<{ [key: string]: string }> }) => {
    //Tricky to adjust this one; would need to change many other definitions on other sections of the code.

    const appId = params.id!;
    const currentUser = spi.getCurrentUser().value;
    const service = deviceManagementContainer.get(DeviceManagementService);

    const appByIdQuery$ = service.getApplicationById(appId);
    let appByIdQuery: InnerType<ReturnType<typeof service.getApplicationById>> | null = null;
    try {
      appByIdQuery = await firstValueFrom(appByIdQuery$.pipe(filter((app) => !!app)));
    } catch {
      throw new Response('', { status: 500 });
    }

    if (appByIdQuery?.provider?.id !== currentUser.parent.id) {
      throw new Response('', { status: 403 });
    }

    return capabilitiesForRouteAccess(spi, ['apps.version.create']);
  };
}
